// src/pages/steps/ShippingStep.js
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel, Input, VStack } from "@chakra-ui/react";

const ShippingStep = () => {
  const { register } = useFormContext();

  return (
    <VStack spacing={4} align="stretch">
      <FormControl>
        <FormLabel>Fullt navn</FormLabel>
        <Input {...register("shipping.name")} placeholder="Ola Nordmann" />
      </FormControl>
      <FormControl>
        <FormLabel>Adresse</FormLabel>
        <Input {...register("shipping.address")} placeholder="Gate 1" />
      </FormControl>
      <FormControl>
        <FormLabel>Postnummer</FormLabel>
        <Input {...register("shipping.zip")} placeholder="1234" />
      </FormControl>
      <FormControl>
        <FormLabel>By</FormLabel>
        <Input {...register("shipping.city")} placeholder="Oslo" />
      </FormControl>
      <FormControl>
        <FormLabel>Land</FormLabel>
        <Input {...register("shipping.country")} placeholder="Norge" />
      </FormControl>
    </VStack>
  );
};

export default ShippingStep;